import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getShopsList } from 'src/app/data/store/actions/shop.action';
import { selectCurrentPlatform } from 'src/app/data/store/selectors/platform.selectors';
import { CurrentPlatform, ShopsListTypes } from 'src/app/shared/enums';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { IonPageContentComponent } from '../../../../../../shared/components/ion-page-container/ion-page-content/ion-page-content.component';
import { IonicModule } from '@ionic/angular';
import { BlockComponent } from '../../../../../../shared/components/block/block.component';
import { CommonShopsListComponent } from '../../../../../../shared/components/common-shops-list/common-shops-list.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-shop-list',
  templateUrl: './shop-list.component.html',
  styleUrls: ['./shop-list.component.scss'],
  imports: [
    IonPageContentComponent,
    IonicModule,
    BlockComponent,
    CommonShopsListComponent,
    AsyncPipe,
  ],
})
export class ShopListComponent {
  private _utils = inject(UtilsService);
  private _store = inject(Store);

  public readonly platform = CurrentPlatform;

  public shopsListTypes = ShopsListTypes;

  public currentPlatform$: Observable<CurrentPlatform | null> | undefined =
    this._store.select(selectCurrentPlatform);

  constructor() {
    this.getShops = this.getShops.bind(this);
  }

  public getShops() {
    this._store.dispatch(getShopsList());
  }

  public onRefresh(event: Event) {
    this._utils.handleRefresh(event, undefined, this.getShops);
  }
}
